export function mergeUrlWithAdditionalQuery(url: string, query: string) {
  return url.includes('?') ? `${url}&${query}` : `${url}?${query}`;
}
